import { Avatar, Button, Stack, Typography } from '@mui/material';
import { CustomDialog } from 'Components/CustomDialog';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { FamilyMembersIntro } from 'Images';

interface ILawyerDialog {
  showDialog: boolean;
  setShowDialog: (showDialog: boolean) => void;
}

export const LawyerDialog = ({ showDialog, setShowDialog }: ILawyerDialog) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Lawyers);
  const isDesktop = useIsDesktop();

  return (
    <CustomDialog
      height={isDesktop ? '540px' : '400px'}
      width={isDesktop ? '600px' : undefined}
      showDialog={showDialog}
      onclose={() => setShowDialog(false)}
    >
      <Stack pt='64px' gap='12px' alignItems='center'>
        <Avatar
          alt=''
          src={FamilyMembersIntro}
          sx={{ width: '142px', height: '97px' }}
        />
        <Typography
          sx={{
            fontSize: isDesktop ? '32px !important' : '20px !important',
            lineHeight: isDesktop ? '40px !important' : '24px !important',
            fontWeight: 700,
          }}
        >
          {dictionary.didNotSelect}
        </Typography>
        <Typography
          sx={{
            fontSize: isDesktop ? '20px !important' : '16px !important',
            lineHeight: isDesktop ? '26px !important' : '20px !important',
            fontWeight: '400 !important',
            maxWidth: '34ch',
            textAlign: 'center',
          }}
        >
          {dictionary.goBackToList}
        </Typography>
        <Button
          sx={{
            width: isDesktop ? '234px' : '208px',
            height: isDesktop ? '46px' : '44px',
            mt: isDesktop ? '80px' : '40px',
          }}
          variant='contained'
          onClick={() => setShowDialog(false)}
        >
          <Typography
            sx={{
              fontSize: isDesktop ? '18px !important' : '16px !important',
              lineHeight: isDesktop ? '22px !important' : '20px !important',
              fontWeight: 700,
            }}
          >
            {dictionary.backToList}
          </Typography>
        </Button>
      </Stack>
    </CustomDialog>
  );
};
